/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import vuexI18n from 'vuex-i18n';
import {Vue} from 'vue-property-decorator';
import {Store} from 'vuex';
import {RootState} from '@/store/types';
import LanguageService from '@/services/language';

/**
 * Vuex translation configuration method.
 *
 * Note: the default translations are provided by a packaged en file.  Alternative translations should be provided by
 * an api service and wired in via axios and local storage.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default (store: Store<RootState>): void => {
    // initialize the internationalization plugin on the vue instance. note that
    // the store must be passed to the plugin. the plugin will then generate some
    // helper functions for components (i.e. this.$i18n.set, this.$t) and on the vue
    // instance (i.e. Vue.i18n.set).
    Vue.use(vuexI18n.plugin, store);

    // set the start locale to use
    Vue.i18n.fallback('en');

    // set the start locale to use
    const detectedLanguage: string =  (navigator.language || 'en').toLowerCase();

    // add default language
    Vue.i18n.add('en', require('./en.json'));

    // load saved language selection
    LanguageService.initialiseLanguage(store.getters['settingsModule/language'] || detectedLanguage);
};
